import { Injectable } from '@angular/core';
import { GlobalService } from '../global.service';
import { Observable } from 'rxjs';

@Injectable()
export class StopsService {

  constructor(private globalService: GlobalService) {}

  getNombreStops(): Observable<any> {
    return this.globalService.get('/SP-GetNombreStops/');
  }

  exportNewStops(data: any): Observable<any> {
    return this.globalService.post('/SP-ExportStop/', { ...data, dossier: 'nouveaux' });
  }

  exportAllStops(data: any): Observable<any> {
    return this.globalService.post('/SP-ExportStop/', { ...data, dossier: 'tous' });
  }

  exportReponses(data: any): Observable<any> {
    return this.globalService.post('/SP-ExportStop/', { ...data, dossier: 'reponses' });
  }
}
